import {HistoryInterval} from './tile-dataset';
import {TileValue} from './tile-value';
import {
  TILE_FORMAT_MULTICHOICE,
  TILE_FORMAT_NUMERIC,
  TILE_FORMAT_TOGGLE,
  TILE_TYPE_SIMPLE_ANALOG, TILE_TYPE_SIMPLE_BOOL,
  TILE_TYPE_SIMPLE_MULTISTATE,
  TileId,
  TileType,
} from './tile';
import {Device, DeviceId} from './device';
import {ModbusPoint} from './modbus';
import {Protocol} from './protocol';
import {LoRaWANDevicePoint} from './lorawan';

export interface PointValue {
  PointID?: string;
  MotionDeviceID?: DeviceId;
  BACnetDeviceID?: DeviceId;
  Value: number | boolean;

  /**
   * RFC-3339 timestamp; e.g. "2019-10-12T07:20:50.52Z".
   */
  Time?: string;
}

export interface PointValueQuery {
  tileId: TileId;
  Quantity: number;
  Interval: HistoryInterval;
  TileValues: TileValue[];
  Truncated: boolean;
}

export type PointId = string;

export enum BacnetPointType {
  AnalogValue = 'analogValue',
  AnalogInput = 'analogInput',
  AnalogOutput = 'analogOutput',
  BinaryValue = 'binaryValue',
  BinaryInput = 'binaryInput',
  BinaryOutput = 'binaryOutput',
  MultiStateValue = 'multiStateValue',
  MultiStateInput = 'multiStateInput',
  MultiStateOutput = 'multiStateOutput'
}

export interface BacnetPoint {
  ID?: PointId;
  Address: string;
  Description: string;
  UnitsState: string | Array<string>;
  Name: string;
  Overridden: boolean;
  Protocol: Protocol;
  Type: BacnetPointType;
  Value: boolean | number;
}

export enum BacnetPointSupertype {
  Analog = 'analog',
  Binary = 'binary',
  Multistate = 'multistate'
}

export const tileFormatToBacnetSupertypeMap: { [tileFormat: string]: BacnetPointSupertype } = {};
tileFormatToBacnetSupertypeMap[TILE_FORMAT_NUMERIC] = BacnetPointSupertype.Analog;
tileFormatToBacnetSupertypeMap[TILE_FORMAT_MULTICHOICE] = BacnetPointSupertype.Multistate;
tileFormatToBacnetSupertypeMap[TILE_FORMAT_TOGGLE] = BacnetPointSupertype.Binary;

export const tileFormatToTileTypeMap: { [tileFormat: string]: TileType } = {};
tileFormatToTileTypeMap[TILE_FORMAT_NUMERIC] = TILE_TYPE_SIMPLE_ANALOG;
tileFormatToTileTypeMap[TILE_FORMAT_MULTICHOICE] = TILE_TYPE_SIMPLE_MULTISTATE;
tileFormatToTileTypeMap[TILE_FORMAT_TOGGLE] = TILE_TYPE_SIMPLE_BOOL;

/**
 * These two func types receive a BacnetPoint object and a Device object that are ready to be
 * immediately used to create a new Tile object.
 */
export type BacnetPointSelectionCallback = (p: BacnetPoint, d: Device) => void;
export type ModbusPointSelectionCallback = (p: ModbusPoint, tt: TileType, d: DeviceId) => void;
export type LoRaWANPointSelectionCallback = (p: LoRaWANDevicePoint) => void;
